// extracted by mini-css-extract-plugin
module.exports = {"location":"styles-module__location___11FHK"};